import React from "react";
import config from "../data/siteConfig";
import galleryItems from "../data/gallery";
import { Keystone, BandhaniField, BlockPrintBg } from "./Decor";
import { categoryIcons } from "./icons";
import { FiArrowRight } from "react-icons/fi";
import { GiCutDiamond } from "react-icons/gi";

const coverFor = (catId) => {
  const hit = galleryItems.find((g) => g.cat === catId);
  return hit ? hit.src : galleryItems[0].src;
};

export default function Categories({ onSelect }) {
  return (
    <section id="collections" className="relative overflow-hidden bg-coffee-grad py-20 text-cream md:py-28">
      <BlockPrintBg className="absolute inset-0 text-gold" opacity={0.07} />
      <BandhaniField className="absolute inset-0 text-gold" opacity={0.05} />

      <div className="container-x relative">
        <div className="text-center">
          <span className="eyebrow !text-gold">What we craft</span>
          <h2 className="mt-2 font-display text-3xl text-gold-light sm:text-4xl">Our Collections</h2>
          <div className="mt-3 flex justify-center text-gold">
            <span className="h-px w-16 self-center bg-gradient-to-r from-transparent to-gold" />
            <GiCutDiamond className="mx-3 self-center text-base" />
            <span className="h-px w-16 self-center bg-gradient-to-l from-transparent to-gold" />
          </div>
          <p className="mx-auto mt-4 max-w-xl text-cream/80">
            Explore our range of handcrafted gold &amp; silver ornaments, each rooted in Kutchi tradition.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-5 md:grid-cols-4">
          {config.categories.map((c) => {
            const Icon = categoryIcons[c.id] || GiCutDiamond;
            return (
            <a
              key={c.id}
              href="#gallery"
              onClick={() => onSelect && onSelect(c.id)}
              className="reveal group relative block"
            >
              <div className="absolute -top-3 left-1/2 z-10 -translate-x-1/2 text-gold opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                <Keystone className="h-6 w-6" />
              </div>
              <div className="overflow-hidden rounded-t-[44%] rounded-b-md p-1.5 ring-2 ring-gold/50 transition-all duration-300 group-hover:ring-gold">
                <div className="relative overflow-hidden rounded-t-[42%] rounded-b-md">
                  <img
                    src={coverFor(c.id)}
                    alt={c.name}
                    loading="lazy"
                    className="aspect-[3/4] w-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-coffee-950/90 via-coffee-950/10 to-transparent" />
                  <div className="absolute inset-x-0 bottom-0 p-4 text-center">
                    <Icon className="mx-auto text-2xl text-gold-light" />
                    <h3 className="mt-1 font-display text-base text-cream">{c.name}</h3>
                    <span className="inline-flex items-center gap-1 text-[0.62rem] uppercase tracking-[0.2em] text-gold-light/90">
                      View Designs <FiArrowRight />
                    </span>
                  </div>
                </div>
              </div>
            </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
